import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { SiFormItemComponent } from '@siemens/element-ng/form';
import { DashboardTileComponent } from '../../dashboard-tile/dashboard-tile.component';
import { NumberInputComponent } from '../../form/number-input';
import { ApplicationDetailDashboardBoxComponent } from '../application-detail-dashboard-box/application-detail-dashboard-box.component';
import { SimpleBaseEffectiveControlComponent } from '../simple-base-effective-control.component';

@Component({
    selector: 'tran-application-detail-employee-learning-hours',
    templateUrl: './application-detail-employee-learning-hours.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        ApplicationDetailDashboardBoxComponent,
        DashboardTileComponent,
        SiFormItemComponent,
        NumberInputComponent,
        TranslatePipe,
        ReactiveFormsModule
    ]
})
export class ApplicationDetailEmployeeLearningHoursComponent extends SimpleBaseEffectiveControlComponent<
    number | null | undefined
> {}
